import { FC } from "react";
import DateSelectContent from "../../DateSelectContent/DateSelectContent";

const ArrivalComponentWeb: FC<any> = ({ icon: Icon, hasError, ...props }) => {
  return (
    <div className="flex w-full flex-1 items-center gap-1 md:w-auto">
      <div className={hasError ? "text-font-danger" : "text-font-minimal!"}>
        <Icon className="h-4! w-4!" />
      </div>
      <DateSelectContent {...props} />
    </div>
  );
};

export default ArrivalComponentWeb;
